import { withTranslation } from "react-i18next";

import ContactThumbnailUrl from "/assets/contact-thumbnail.jpg";
import styles from "./ContactCard.module.css";

export default withTranslation()(function ContactCard({
  t,
  contact
}) {

  const cleanNumber = (str) => {
    const digitsOnly = str.replace(/\D/g, '');
    if (digitsOnly.length > 0 && digitsOnly[0] === '8') {
      return '7' + digitsOnly.substring(1);
    }
    return digitsOnly;
  };

  const phoneNumber = contact.whatsapp_number && cleanNumber(contact.whatsapp_number);
  const formattedPhoneNumber = phoneNumber &&
    `+${phoneNumber[0]} ${phoneNumber.substring(1, 4)} ${phoneNumber.substring(4, 7)} ${phoneNumber.substring(7, 11)}`;

  return (
    <div className={styles.contactCard}>
      <img src={contact.photo?.url || ContactThumbnailUrl} />

      <div className={styles.info}>
        <div className={styles.head}>
          <span>{t("collections.producer")}</span>
          <h2 className={styles.name}>{contact.name}</h2>
        </div>

        <div className={styles.contacts}>
          {phoneNumber && (
            <span>{formattedPhoneNumber}</span>
          )}
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
          {contact.telegram_username && (
            <a href={`https://t.me/${contact.telegram_username}`}>{t("collections.contacts.telegram")}</a>
          )}
          {phoneNumber && (
            <a href={`https://wa.me/${phoneNumber}?text=`}>{t("collections.contacts.whatsapp")}</a>
          )}
        </div>
      </div>
    </div>
  );
});
